<template>
  <div class="my-aftermarket-index-div1">
    <table style="width: 100%;" cellspacing="0" cellpadding="0">
      <tr height="50px">
        <td>
          <div class="my-aftermarket-index-div2">
            <span class="my-aftermarket-index-span1">售后服务</span>
          </div>
        </td>
      </tr>
      <tr>
        <td class="my-aftermarket-index-td2">
          <span v-html="content" class="my-aftermarket-index-span2"></span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import Vuex from 'vuex'
  import {
    getInfoDesc,
  } from '@/api/InfoDesc.js'

  export default {
    name: "AftermarketIndex",
    data() {
      return {
        content: "",
      };
    },
    components: {},
    methods: {

    },
    computed: {
      ...Vuex.mapGetters(["getInfo"])
    },
    created() {
      getInfoDesc('info/getDesc?type=3', this);
      this.$store.state.activeIndex = "5";
    }
  }
</script>

<style>
  .my-aftermarket-index-div1 {
    width: 1200px;
    margin: 0 auto;
  }

  .my-aftermarket-index-span1 {
    font-size: 25px;
    font-weight: bold;
    color: white;
  }

  .my-aftermarket-index-div2 {
    width: 260px;
    background: royalblue;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }

  .my-aftermarket-index-td2 {
    border: 0px hidden;
    background: white;
    text-align: left;
  }

  .my-aftermarket-index-span2 {
    text-indent: 2em;
    font-size: 18px;
  }

  p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/aftermarket/AftermarketIndex.vue